






import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class BackTop extends Vue {
  @Prop({
    default: () => window,
  }) public scrollEl!: HTMLElement;

  public handleClick() {
    if (this.scrollEl) {
      this.$u.controlScroll({
        el: this.scrollEl,
        duration: 350,
        y: 0,
      });
    }
  }
}
